import * as D from 'io-ts/Decoder';
import { FeedbackRequest } from 'src/modules/feedback/types/FeedbackRequest';

export const FEEDBACK_REQUEST: D.Decoder<unknown, FeedbackRequest> = D.struct({
  triggered: D.boolean,
});
